import React, { useState } from 'react'
 
 
import ProcurementTargetList from './ProcurementTargetList';
import ProcurementTargetForm from './ProcurementTargetForm';

const ProcurementTarget= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <ProcurementTargetForm addForm={setFromIsShown} update={upData} />
        ) : (
          <ProcurementTargetList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default ProcurementTarget